import React from 'react';
import { connect } from 'react-redux';
import { withRouter , Link} from 'react-router';
import * as PatientsActions from '../../../actions/admin/patients_actions';
import * as FacilitiesActions from '../../../actions/facilities_actions';
import * as SettingScreen from '../../../actions/settingScreen_actions';
import { bindActionCreators } from 'redux';
import { ModalDialogCommon } from '../../modal_dialog_common';
import { validate } from '../../../validations';
import Header from '../../../components/header';
import { RestPwdDialog } from '../../../components/reset_pwd_dialog';
let screenIdentifier = 'patientsDetails';
import _ from 'lodash';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import InputMask from 'react-input-mask';
import * as UserActions from '../../../actions/user_actions';


export var EditPatient = React.createClass({
  getInitialState() {
    return {
      staff_data: null,
      isFormSubmitted: null,
      errorMessage: null,
      okModalMessage: null,
      isUpdateUserSucceed: null,
      mobileCssClass: "inputText",
      PsychiatristList: [],
      TheraoistList: [],
    }
  },
  componentWillMount() {

    var facility_id = this.props.UserDetails.selectdUserFacilityID;
    this.props.Dispatch(UserActions.getTherapistList(facility_id));
    this.props.Dispatch(UserActions.getPsychiatristList(facility_id));
  },

  componentWillReceiveProps(nextProps) {

    nextProps.UserDetails.PsychiatristList && nextProps.UserDetails.PsychiatristList.status == 200 && this.setState({ PsychiatristList: nextProps.UserDetails.PsychiatristList.data });
    nextProps.UserDetails.TheraoistList && nextProps.UserDetails.TheraoistList.status == 200 && this.setState({ TheraoistList: nextProps.UserDetails.TheraoistList.data });

    if (this.state.isFormSubmitted && nextProps.Setting.profileUpdate) {
      this.setState({ isFormSubmitted: null });
      if (nextProps.Setting.profileUpdate.status === 200) {
        this.setState({ isUpdateUserSucceed: true, okModalMessage: nextProps.Setting.profileUpdate.message });
        this.props.Dispatch(FacilitiesActions.getAdminUserById(this.props.FacilitiesDetails.FaciliteAdminUser.data.id+"/"+this.props.UserDetails.selectdUserFacilityID));
      }
      else {
        this.setState({ isUpdateUserSucceed: null, okModalMessage: nextProps.Setting.profileUpdate.message })
      }
    }
  },

  componentDidMount() {

  },
  getPatientsDetail() {

    var details = this.props.FacilitiesDetails.FaciliteAdminUser.data;
    return { details: details, staff_data: this.props.PatientsDetails.AllPatientsData.data };
  },

  remove_error(event) {
    event.target.type === "text" ? event.target.className = 'inputText' : event.target.className = '';
  },

  editFacility() {
    var facility_id = this.props.UserDetails.selectdUserFacilityID;
    let firstName = this.refs.firstName.value.trim(),
      lastName = this.refs.lastName.value.trim(),
      mobile = this.refs.mobile.state.value.replace(/ /g, ""),
      userName = this.refs.userName.value.trim(),
      psychiatrist = this.refs.psychiatrist.value.trim(),
      therapist = this.refs.therapist.value.trim(),
      email = this.refs.email.value.trim();
    let isValidMobile = validate.phone(mobile);

    !validate.email(email) ? this.refs.email.className = "inputText error" : this.refs.email.className = "inputText";
    !email.length ? this.refs.email.className = "inputText error" : this.refs.email.className = "inputText";
    !firstName.length ? this.refs.firstName.className = "inputText error" : this.refs.firstName.className = "inputText";
    !lastName.length ? this.refs.lastName.className = "inputText error" : this.refs.lastName.className = "inputText";
    //!userName.length ? this.refs.userName.className = "inputText error" : this.refs.userName.className = "inputText";

    // !psychiatrist.length ? this.refs.psychiatrist.parentElement.parentElement.parentElement.className = 'aj-dropdown with-label error-border-bottom' : this.refs.psychiatrist.parentElement.parentElement.parentElement.className = 'aj-dropdown with-label';
    // !therapist.length ? this.refs.therapist.parentElement.parentElement.parentElement.className = 'aj-dropdown with-label error-border-bottom' : this.refs.therapist.parentElement.parentElement.parentElement.className = 'aj-dropdown with-label';
    if (psychiatrist.length || therapist.length) {
      this.refs.psychiatrist.parentElement.parentElement.parentElement.className = 'aj-dropdown with-label';
      this.refs.therapist.parentElement.parentElement.parentElement.className = 'aj-dropdown with-label';
    }
    else {
      this.refs.psychiatrist.parentElement.parentElement.parentElement.className = 'aj-dropdown with-label error-border-bottom';
      this.refs.therapist.parentElement.parentElement.parentElement.className = 'aj-dropdown with-label error-border-bottom';
    }

    !isValidMobile ? this.setState({ mobileCssClass: 'inputText error' }) : this.setState({ mobileCssClass: 'inputText' });
    let phyOrTherp = !(psychiatrist.length != 0 || therapist.length != 0);
    if (email.length === 0 || firstName.length === 0 || lastName.length === 0 || mobile.length === 0 || phyOrTherp  ) { //userName.length === 0 ||
      this.setState({ errorMessage: "Please enter necessary fields to proceed." });
      return false;
    }
    if (!phyOrTherp && firstName.length && lastName.length && mobile.length && isValidMobile) {
      this.setState({ errorMessage: null });
      var data = {
        "id": this.props.FacilitiesDetails.FaciliteAdminUser.data.id,        //admin_user_id mandatory
        "uniqueKey": this.props.FacilitiesDetails.FaciliteAdminUser.data.uniqueKey, //mandatory
        "firstName": firstName,
        "lastName": lastName,
      //  "userName": userName,
        "email":email,
        "mobile": mobile,
        "createdBy": { "id": this.props.UserDetails.loginData.data.id, role: { "id": this.props.UserDetails.selectedUserRoleID } },
        "facility": { "id": facility_id },
        "role": { "id": 7 }, // Type of user hard coded for patients

      }

      if (psychiatrist.length) {
        data.psychiatrist = { "id": psychiatrist }
      }
      if (therapist.length) {
        data.therapist = { "id": therapist }
      }

      this.setState({ isFormSubmitted: true });
      this.props.Dispatch(SettingScreen.profileUpdate(data));
    }
    else {
      this.setState({ errorMessage: "Please enter valid information to proceed." });
    }
  },
  cancel() { this.props.router.goBack(); },
  closebox() {
    this.setState({ okModalMessage: null });
    if (this.state.isUpdateUserSucceed) {
      this.setState({ isUpdateUserSucceed: null });
      let facilitiesID = this.props.UserDetails.selectdUserFacilityID;
      this.props.Dispatch(PatientsActions.getAllPaientsData(facilitiesID));
      this.props.router.goBack();
    }
  },

  no_empty(event) {
    event.target.value.trim().length > 0 ? event.target.className = 'inputText' : event.target.className = 'inputText error';
  },
  selectionChanged(event) {
    event.target.value != "" ? event.target.parentElement.parentElement.parentElement.className = 'aj-dropdown with-label' : event.target.parentElement.parentElement.parentElement.className = 'aj-dropdown with-label error-border-bottom';
  },
  phone_Validate(event) {
    validate.phone(event.target.value) ? event.target.className = 'inputText' : event.target.className = 'inputText error';
  },

  render() {

    var _patientsDetails = this.getPatientsDetail();

    var Psychiatrist = this.state.PsychiatristList ? this.state.PsychiatristList : [];
    var psychiatristOptions = Psychiatrist.map(function (list, key) {
      return (<option value={list.id} key={key}>{list.firstName + " " + list.lastName}</option>)
    }, this);

    var Therapist = this.state.TheraoistList;
    var therapistOptions = Therapist.map(function (list, key) {
      return (<option value={list.id} key={key}>{list.firstName + " " + list.lastName}</option>)
    }, this);

    return (
      <div className="dashboard-inner-content">
        <Header screenIdentifier={screenIdentifier} breadcrumb={true} />
        <div className="breadcrumb-custom">
          <h2> <Link to="/patients">PATIENTS</Link> > <a onClick={this.props.router.goBack} >{this.props.FacilitiesDetails.FaciliteAdminUser.data.firstName}</a> > Edit</h2>
        </div>
        <div className="white-box">
          <div className="edit-facility">
            <h4>EDIT PATIENT</h4>
            <div className="row">
              <div className="col-xs-11 no-padding">
                <div className="col-xs-6 no-padding facility-details">
                  <div className="input-group">
                    <input type="text" className="inputText" ref="firstName" onFocus={this.remove_error} defaultValue={_patientsDetails.details.firstName} onBlur={this.no_empty} maxLength="64" required />
                    <span className="floating-label">FIRST NAME</span>
                  </div>
                  <div className="input-group readonly" >
                    <input type="text" className="inputText" tabIndex="-1" ref="userName" defaultValue={_patientsDetails.details.userName} onBlur={this.no_empty} maxLength="64" required />
                    <span className="floating-label">USER NAME</span>
                  </div>
                  <div className={_patientsDetails.details.status=="ACCEPTED" ? "input-group":"input-group readonly" }>
                    <input type="text" className="inputText" tabIndex="-1" ref="email" defaultValue={_patientsDetails.details.email} />
                    <span className="floating-label">EMAIL</span>
                  </div>
                  <div className="input-group readonly">
                    <input type="text" className="inputText" tabIndex="-1" required defaultValue={_patientsDetails.details.facilities ? _patientsDetails.details.facilities[0].facility.name : ""} />
                    <span className="floating-label">CLINIC</span>
                  </div>
                  <div>
                    {this.state.errorMessage && <span className="red-color">{this.state.errorMessage}</span>}
                  </div>
                </div>
                <div className="col-xs-6 no-padding facility-details">
                  <div className="input-group">
                    <input type="text" className="inputText" ref="lastName" onFocus={this.remove_error} defaultValue={_patientsDetails.details.lastName} onBlur={this.no_empty} maxLength="64" required />
                    <span className="floating-label">LAST NAME</span>
                  </div>
                  <div className="input-group">
                    <InputMask type="text" className={this.state.mobileCssClass} onFocus={this.remove_error} defaultValue={_patientsDetails.details.mobile} ref="mobile" mask="999 999 9999" maskChar={null} onBlur={this.phone_Validate} required></InputMask>
                    <span className="floating-label">PHONE</span>
                  </div>
                  <div className="aj-dropdown with-label">
                    <label>PSYCHIATRIST ASSIGNED</label>
                    <div className="source">
                      <div className="question-selection">
                        <select ref="psychiatrist" defaultValue={_patientsDetails.details.psychiatrist && _patientsDetails.details.psychiatrist.id} onChange={this.selectionChanged} onFocus={this.selectionChanged} onBlur={this.selectionChanged} required>
                          <option value="" default>Please select</option>
                          {psychiatristOptions}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="aj-dropdown with-label">
                    <label>THERAPIST ASSIGNED</label>
                    <div className="source">
                      <div className="question-selection">
                        <select ref="therapist" defaultValue={_patientsDetails.details.therapist && _patientsDetails.details.therapist.id} onChange={this.selectionChanged} onFocus={this.selectionChanged} onBlur={this.selectionChanged} required>
                          <option value="" default>Please select</option>
                          {therapistOptions}
                        </select>
                      </div>
                    </div>
                  </div>

                </div>

              </div>
            </div>
            <button className="gray-button" onClick={this.editFacility}>Save</button>
            <button className="white-button" onClick={this.cancel}>Cancel</button>
          </div>
        </div>
        {this.state.okModalMessage && <ModalDialogCommon message={this.state.okModalMessage} action={this.closebox} />}
      </div>
    );
  }
});

let mapStateToProps = (state) => {
  return {
    PatientsDetails: state.Patients,
    UserDetails: state.User,
    Setting: state.Setting,
    FacilitiesDetails: state.Facilites

  };
};

let mapDispatchToProps = (dispatch) => ({
  PatientsActions: bindActionCreators(PatientsActions, dispatch),
  FacilitiesActions: bindActionCreators(FacilitiesActions, dispatch),
  Dispatch: dispatch
});
export default connect(mapStateToProps,
  mapDispatchToProps)(withRouter(EditPatient));



/** WEBPACK FOOTER **
 ** ./src/components/admin/patients/edit-patient.js
 **/